// Funktion, um den Warenkorb abzurufen
function fetchCart() {
    return new Promise((resolve, reject) => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => resolve(data))
            .catch(error => reject(error));
    });
}


function calculateShippingForLootbox(locale){
    fetchCart().then(cart => {
         fetch(`/cart/shipping_rates.json`) 
           .then(response => {
          if (!response.ok) {
              throw new Error(shipping_error_general);
          }
          return response.json();
      })
      .then(data => {
          const rates = data.shipping_rates;
      });
    });
}